import { useState } from "react";
import "./GalleryLayout.css";

export default function GridView({
  setSelectedPhoto,
  updateSelectedCheckboxes,
  images,
  checkedState,
  onPhotoClick,
  onSelectionCountChange,
  BASE_URL
}) {
  const handleDivClick = (index) => {
    const clickedItem = images[index];
    const clickedGalleryId = clickedItem.galleryId;

    const updatedCheckedState = checkedState.map((checked, i) =>
      images[i].galleryId === clickedGalleryId ? !checked : false
    );
    updateSelectedCheckboxes(updatedCheckedState);

    const selectedImages = images.filter((_, i) => updatedCheckedState[i]);
    onSelectionCountChange(selectedImages.length);

    if (selectedImages.length === 1) {
      setSelectedPhoto(selectedImages[0].imgUrl || selectedImages[0].documentUrl);
      onPhotoClick(selectedImages[0].galleryId);
    } else if (selectedImages.length > 1) {
      setSelectedPhoto(selectedImages[0].imgUrl || selectedImages[0].documentUrl);
    } else {
      setSelectedPhoto("");
    }
  };

  const isImageFile = (url) => {
    if (!url) return false;
    const extension = url.split(".").pop().toLowerCase();
    return ["jpg", "jpeg", "png", "webp", "bmp"].includes(extension);
  };

  const isOfficeFile = (url) => {
    if (!url) return false;
    const extension = url.split(".").pop().toLowerCase();
    const officeExtensions = [
      "pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv", "rtf"
    ];
    return officeExtensions.includes(extension);
  };

  return (
    <>
      <div className="grid_view_layout">
        {images.map((image, index) => {
          const fileUrl = image.imgUrl || image.documentUrl;
          return (
          <div
            key={image.galleryId}
            className={`grid_image_card ${checkedState[index] ? 'selected' : ''}`}
            onClick={() => handleDivClick(index)}
          >
            <div className="grid_image_checkbox_wrapper">
              <input type="checkbox" checked={checkedState[index]} readOnly />
            </div>
            <div className="grid_image_container">
              {isImageFile(fileUrl) ? (
                <img
                  src={BASE_URL + fileUrl}
                  alt={image.name}
                  className="grid_card_img"
                />
              ) : isOfficeFile(fileUrl) ? (
                <div className="grid_file_placeholder d-flex flex-column align-items-center justify-content-center">
                  <img src="/build/img/Icons/Paperclip.svg" alt="File" width="30" height="30" />
                  <span className="mt-1 text-uppercase fw-bold" style={{ fontSize: '10px' }}>
                    {fileUrl?.split(".").pop()}
                  </span>
                </div>
              ) : (
                <div className="grid_file_placeholder d-flex flex-column align-items-center justify-content-center">
                  <img src="/build/img/Icons/Paperclip.svg" alt="File" width="30" height="30" />
                  <span className="mt-1 text-uppercase fw-bold" style={{ fontSize: '10px' }}>
                    {fileUrl?.split(".").pop()}
                  </span>
                </div>
              )}
            </div>
          </div>
          );
        })}
      </div>
    </>
  );
}
